import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import apiGateWay from '../../serviceHandler';
import Swal from "sweetalert2";
import "./MenuStart.css"; 

const Index = () => {
  const urlParams = useParams();
  const navigate = useNavigate();
  const orderType = sessionStorage.getItem("orderType");

  const [hotelsList, setHotelsList] = useState([]);
  const [guestDetailsFormErrors, setGuestDetailsFormErrors] = useState({});
  const [guestDetails, setGuestDetails] = useState({
    firstName: '',
    lastName: '',
    mobileNumber: '',
    hotelId: '', 
    roomNumber: '',
  });

  useEffect(() => {
    if (orderType === "online_payment") {
      navigate(
        `/ezmenu/${urlParams.tableNumer}/${urlParams.rvc}/${urlParams.zone}/${urlParams.actualTableNumber}`
      );
      return;
    }
    fetchHotels();
  }, [orderType, navigate, urlParams]);

  if (orderType === "online_payment") {
    return null;
  }

  const fetchHotels = async () => {
    try {
      const locationId = urlParams.tableNumer || 100;
      const response = await apiGateWay.get('/keyconnect/simphony/GetHotels', { params: { LocationId: locationId } });
      if (response.data && response.data.result && response.data.result.data) {
        const hotels = response.data.result.data;
        setHotelsList(hotels);
        if (hotels.length > 0) {
          setGuestDetails(prev => ({ ...prev, hotelId: hotels[0].id }));
        }
      }
    } catch (error) {
      console.error("Failed to fetch hotels:", error);
    }
  };

  const handleGuestDetailsChange = (ev) => {
    const { name, value } = ev.target;
    
    let error = "";
    if (name === "firstName" && !value.trim()) {
      error = "First Name is required";
    } else if (name === "lastName" && !value.trim()) {
      error = "Last Name is required";
    } else if (name === "mobileNumber") {
      if (value.trim() && !/^\d{10}$/.test(value)) {
        error = "Mobile Number must be 10 digits if provided";
      }
    } else if (name === "roomNumber") {
      if (!value.trim()) {
        error = "Room Number is required";
      } else if (isNaN(Number(value)) || Number(value) <= 0) {
        error = "Room Number must be a positive number";
      }
    }

    setGuestDetailsFormErrors(prevErrors => ({
      ...prevErrors,
      [name]: error,
    }));

    setGuestDetails(prevDetails => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleViewMenuNavigation = (ev) => {
    ev.preventDefault();

    let hasError = false;
    const newErrors = {};

    if (!guestDetails.firstName?.trim()) {
      newErrors.firstName = "First Name is required";
      hasError = true;
    }

    if (!guestDetails.lastName?.trim()) {
      newErrors.lastName = "Last Name is required";
      hasError = true;
    }
    
    if (orderType !== "room_posting") {
      if (guestDetails.mobileNumber?.trim()) {
        if (!/^\d{10}$/.test(guestDetails.mobileNumber)) {
          newErrors.mobileNumber = "Mobile Number must be 10 digits";
          hasError = true;
        }
      }
    }

    if (orderType !== "online_payment") {
      if (!guestDetails.hotelId) {
        newErrors.hotelId = "Hotel Name is required";
        hasError = true;
      }
      if (!guestDetails.roomNumber?.trim()) {
        newErrors.roomNumber = "Room Number is required";
        hasError = true;
      }
    }

    setGuestDetailsFormErrors(newErrors);

    if (hasError) {
      return;
    }

    sessionStorage.setItem("guestDetails", JSON.stringify(guestDetails));

    navigate(
      `/ezmenu/${urlParams.tableNumer}/${urlParams.rvc}/${urlParams.zone}/${urlParams.actualTableNumber}`
    );
  };

  const isButtonDisabled = () => {
    let status = !guestDetails.firstName.trim() || !guestDetails.lastName.trim();
    if (orderType !== "room_posting") {
      if (guestDetails.mobileNumber.trim() && !/^\d{10}$/.test(guestDetails.mobileNumber)) {
        status = true;
      }
    }
    if (orderType !== "online_payment") {
      status = status || !guestDetails.hotelId || !guestDetails.roomNumber.trim();
    }
    return status || Object.values(guestDetailsFormErrors).some(error => error !== "");
  };

  return (
    <div className="startWrap">
      <div className="start-menu-wrapper">
        {/* Logo with color filter to make it #466cf6 */}
        <img
          src="/images/Wild-Wadi-Logo_white.png"
          alt="EZmenu"
          className="logo-icon colored-logo"
        />

        <div className="guest-details-form">
          <div className="guest-field-group">
            <label className="guest-field-label">First Name <span className="text-danger">*</span></label>
            <input
              type="text"
              className="guest-text-input"
              name="firstName"
              value={guestDetails.firstName}
              onChange={handleGuestDetailsChange}
            />
            {guestDetailsFormErrors.firstName && (
              <span className="guest-error-message">{guestDetailsFormErrors.firstName}</span>
            )}
          </div>

          <div className="guest-field-group">
            <label className="guest-field-label">Last Name <span className="text-danger">*</span></label>
            <input
              type="text"
              className="guest-text-input"
              name="lastName"
              value={guestDetails.lastName}
              onChange={handleGuestDetailsChange}
            />
            {guestDetailsFormErrors.lastName && (
              <span className="guest-error-message">{guestDetailsFormErrors.lastName}</span>
            )}
          </div>
          
          {orderType !== "room_posting" && (
            <div className="guest-field-group">
              <label className="guest-field-label">
                Mobile Number <span className="optional-label">(optional)</span>
              </label>
              <input
                type="text"
                className="guest-text-input"
                name="mobileNumber"
                value={guestDetails.mobileNumber}
                onChange={handleGuestDetailsChange}
                maxLength={10}
                placeholder="Enter 10-digit mobile number (optional)"
              />
              {guestDetailsFormErrors.mobileNumber && (
                <span className="guest-error-message">{guestDetailsFormErrors.mobileNumber}</span>
              )}
            </div>
          )}
          
          {orderType !== "online_payment" && ( 
            <>
              <div className="guest-field-group">
                <label className="guest-field-label">Jumeirah Hotel Name</label>
                <select
                  className="guest-select-input"
                  name="hotelId"
                  value={guestDetails.hotelId}
                  onChange={handleGuestDetailsChange}
                >
                  {hotelsList.length > 0 ? (
                    hotelsList.map(hotel => (
                      <option key={hotel.id} value={hotel.id}>{hotel.hotelName}</option>
                    ))
                  ) : (
                    <option value="">Loading Hotels...</option>
                  )}
                </select>
              </div>
              
              <div className="guest-field-group">
                <label className="guest-field-label">Room Number</label>
                <input
                  type="text"
                  className="guest-text-input"
                  name="roomNumber"
                  value={guestDetails.roomNumber}
                  onChange={handleGuestDetailsChange}
                />
                {guestDetailsFormErrors.roomNumber && (
                  <span className="guest-error-message">{guestDetailsFormErrors.roomNumber}</span>
                )}
              </div>
            </>
          )}

          <div className="button-wrap">
            <button
              onClick={() => navigate("/home")}
              className="guest-back-btn"
            >
              Back to Home
            </button>
            <button
              onClick={handleViewMenuNavigation}
              disabled={isButtonDisabled()}
              className="guest-submit-btn"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;